// @ts-nocheck
/**
 * Recording cell for CDR-style rows (`recording_file`). Reference-mode rows
 * open CdrMediaDetails; inline rows get one audio player per file.
 * Recordings are dropped without Recordings `read` ACL — voicemails stay.
 */
import CdrMediaDetails from './CdrMediaDetails';
import MediaAudioPlayer from './MediaAudioPlayer';
import { getRecordingData, hasCdrMediaReference } from '@/utilities/cdrMedia';
import { canReadRecordings, isVoicemailEntry } from '@/utilities/recordingsAcl';

const CallRecordingCell = ({ recordingFile, compact = true }: any) => {
  if (hasCdrMediaReference(recordingFile)) {
    return <CdrMediaDetails recordingFile={recordingFile} compact={compact} />;
  }

  const canRead = canReadRecordings();
  const recordings = getRecordingData(recordingFile).filter(
    (rec: any) => canRead || isVoicemailEntry(rec),
  );
  if (!recordings.length) return '-';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {recordings.map((rec: any, index: number) => (
        <div key={index}>
          <MediaAudioPlayer src={rec.url} style={{ height: '30px', width: '300px', minWidth: '300px' }} />
          <div style={{ fontSize: '11px', marginTop: '3px' }}>{rec.status}</div>
        </div>
      ))}
    </div>
  );
};

export default CallRecordingCell;
